module.exports = __webpack_public_path__ + "static/media/rectangle.42754850.gif";